const SORT_CARET_MAP = {
  'Answer': 'response.text',
  'Bulb': 'name',
  'Bulbs Built': 'bulbs_built',
  'Bulb Name': 'name',
  'Class Name': 'name',
  'Completed': 'completion_time',
  'Created': 'timestamp',
  'Creator': 'creator',
  'Due Date': 'assigned_date',
  'Email': 'email',
  'Instructor': 'teacher_name',
  'Joined': 'timestamp',
  'Last Login': 'last_login',
  'Last Modified': 'updated',
  'Learner Name': 'student_name',
  'Name': 'teacher_name',
  'Organization': 'school_name',
  'Playlist Name': 'name',
  'Playlist': 'name',
  'Points': 'points',
  'Rigor': 'rigor',
  'Score': 'score',
  'Time Spent (min)': 'engaged_minutes',
  'Views': 'view_count',
};

/**
 * A function to add keyboard accessibility to ElementUI table sorts
 * 
 * @param {Function} sortFunction - the function the different table use to sort
 * @param {String} userView - Instructor, Administration, or Learner
 * @param {String} activeView - The activeView in the dash (What table is currently active)
*/
export function addSortAccessibiltyEvents(sortFunction, userView, activeView) {
  if (
    userView === 'Administration'
    && activeView === 'Schools'
  ) SORT_CARET_MAP['Organization'] = 'name';
  if (
    (
      userView === 'Administration'
      && activeView === 'Bulbs'
    )
    || (
      userView === 'Playlists'
      && activeView === 'Playlists'
    )
  ) SORT_CARET_MAP['Created'] = 'created';
  if (
    userView === 'Folders'
    && (
      activeView === 'Folders'
      || activeView === 'Folder'
    )
  ) SORT_CARET_MAP['Name'] = 'name';
  const caretWrappers = document.getElementsByClassName('caret-wrapper');
  for (const column of caretWrappers) {
    const columnName = column && column.parentElement && column.parentElement.innerText;
    if (columnName.includes('Assigned Date (')) SORT_CARET_MAP[columnName] = 'assigned_date';
    if (columnName.includes('Rigor')) SORT_CARET_MAP[columnName] = 'rigor';
    const carets = column.childNodes;
    for (const caret of carets) {
      caret.setAttribute('role', 'button');
      caret.setAttribute('tabindex', 0);
      caret.setAttribute('aria-label', `Sort ${columnName} column ${caret.classList[1]}`);
      caret.addEventListener('keyup', (event) => {
        if (
          event.code === 'Enter'
          || event.code === 'Space'
        ) sortFunction({
            prop: SORT_CARET_MAP[columnName],
            order: caret.classList[1],
          });
      })
    }
  }
}
